export interface MangaCategory {
  id: string;
  name: string;
  icon: string;
  desc: string;
}

export interface MangaWork {
  id: string;
  title: string;
  cover: string;
  category: string;
  categoryName: string;
  author: string;
  status: "连载中" | "已完结";
  rating: number;
  views: string;
  favorites: string;
  year: number;
  updateTime: string;
  latestChapter: string;
  totalChapters: number;
  description: string;
  tags: string[];
  hot: number;
}

export const siteInfo = {
  name: "43423漫画网",
  slogan: "免费漫画 · 每日更新 · 高清阅读",
  url: "https://workoutpro0.github.io",
  email: "service@43423mh.com",
  phone: "400-1234-3432",
  address: "上海市浦东新区张江高科技园区创新大厦8层",
  icp: "沪ICP备20260628号",
  workHours: "周一至周日 9:00 - 21:00",
};

export const heroBanner =
  "https://readdy.ai/api/search-image?query=Energetic%20manga%20style%20illustration%20of%20a%20fit%20personal%20trainer%20coaching%20happy%20students%20doing%20dumbbell%20workouts%20in%20a%20bright%20modern%20gym%20with%20warm%20orange%20and%20red%20color%20palette%2C%20dynamic%20bold%20anime%20art%2C%20dramatic%20composition%20with%20open%20space%20in%20the%20center%20for%20text%20overlay%2C%20high%20detail%2C%20cinematic%20warm%20lighting&width=1600&height=900&seq=hero-fitness-banner&orientation=landscape";

export const aboutBanner =
  "https://readdy.ai/api/search-image?query=Wide%20panoramic%20manga%20style%20illustration%20of%20a%20cozy%20reading%20community%20corner%20with%20open%20comic%20books%20and%20a%20laptop%20showing%20colorful%20webtoon%20pages%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20soft%20studio%20lighting%2C%20clean%20anime%20art%20style%2C%20welcoming%20atmosphere%2C%20high%20detail&width=1600&height=700&seq=about-banner-x1&orientation=landscape";

export const categories: MangaCategory[] = [
  { id: "all", name: "全部", icon: "ri-apps-2-line", desc: "全站漫画作品" },
  { id: "sports", name: "体育", icon: "ri-medal-line", desc: "热血体育竞技" },
  { id: "hot-blood", name: "热血", icon: "ri-fire-line", desc: "燃爆热血少年" },
  { id: "urban", name: "都市", icon: "ri-building-2-line", desc: "都市生活百态" },
  { id: "romance", name: "恋爱", icon: "ri-heart-2-line", desc: "甜蜜心动日常" },
  { id: "fantasy", name: "玄幻", icon: "ri-sparkling-2-line", desc: "幻想冒险世界" },
  { id: "comedy", name: "搞笑", icon: "ri-emotion-laugh-line", desc: "轻松爆笑解压" },
  { id: "mystery", name: "悬疑", icon: "ri-eye-2-line", desc: "烧脑推理探案" },
];

export const mangaWorks: MangaWork[] = [
  {
    id: "fitness-coach",
    title: "健身教练",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20comic%20cover%20of%20a%20muscular%20male%20personal%20trainer%20in%20an%20orange%20tank%20top%20holding%20a%20dumbbell%20and%20smiling%20confidently%20in%20a%20modern%20gym%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20peach%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20dynamic%20warm%20orange%20lighting%2C%20high%20detail%2C%20energetic%20composition&width=450&height=600&seq=manga-cover-01&orientation=portrait",
    category: "sports",
    categoryName: "体育",
    author: "阿福",
    status: "已完结",
    rating: 9.6,
    views: "1289.6万",
    favorites: "86.2万",
    year: 2020,
    updateTime: "2026-07-30",
    latestChapter: "第358话 完美身材",
    totalChapters: 358,
    description:
      "普通上班族林小北长期久坐、体能糟糕，一次体检报告让他决定改变人生。在金牌健身教练陈锋的魔鬼训练下，他从“健身房小白”一路蜕变，练出了让人羡慕的好身材。这里有真实的健身干货、爆笑的教练学员互动，还有一群为梦想一起流汗的伙伴。健身不只是减脂增肌，更是一场自我重塑的热血修行。",
    tags: ["健身", "都市", "励志", "成长", "热血"],
    hot: 1,
  },
  {
    id: "cat-life",
    title: "猫奴日常",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20happy%20girl%20hugging%20a%20fluffy%20orange%20cat%20at%20home%20surrounded%20by%20cat%20toys%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20cream%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20cozy%20warm%20atmosphere&width=450&height=600&seq=manga-cover-10&orientation=portrait",
    category: "comedy",
    categoryName: "搞笑",
    author: "毛球老师",
    status: "已完结",
    rating: 9.4,
    views: "896.2万",
    favorites: "52.7万",
    year: 2019,
    updateTime: "2026-07-28",
    latestChapter: "第300话 猫咪的报恩",
    totalChapters: 300,
    description:
      "铲屎官小橘和她的高冷橘猫“大王”的爆笑日常。大王傲娇、拆家、半夜跑酷样样精通，小橘一边崩溃一边沉迷吸猫。漫画记录了养猫人的真实酸甜苦辣，看完保证让你又想养猫又怕养猫。",
    tags: ["猫咪", "日常", "治愈", "轻松"],
    hot: 2,
  },
  {
    id: "spirit-courier",
    title: "灵界快递员",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20mysterious%20young%20courier%20carrying%20a%20glowing%20package%20with%20ethereal%20spirit%20light%20in%20a%20night%20city%20silhouette%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20grey%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20mysterious%20atmosphere&width=450&height=600&seq=manga-cover-08&orientation=portrait",
    category: "fantasy",
    categoryName: "玄幻",
    author: "夜行者",
    status: "连载中",
    rating: 9.2,
    views: "634.8万",
    favorites: "38.9万",
    year: 2021,
    updateTime: "2026-07-29",
    latestChapter: "第142话 幽冥快递",
    totalChapters: 142,
    description:
      "白天他是普通外卖员，夜晚他化身灵界快递员，专门配送阴阳两界的特殊包裹。每一单背后都藏着一段未了的心愿与温情故事，轻松搞笑中带点感动，悬疑玄幻中透着人间烟火。",
    tags: ["玄幻", "灵异", "搞笑", "温情"],
    hot: 3,
  },
  {
    id: "fog-detective",
    title: "迷雾侦探社",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20sharp%20young%20detective%20holding%20a%20magnifying%20glass%20in%20a%20foggy%20city%20alley%20at%20night%20with%20a%20street%20lamp%20glow%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20grey%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20mysterious%20atmosphere&width=450&height=600&seq=manga-cover-12&orientation=portrait",
    category: "mystery",
    categoryName: "悬疑",
    author: "灰雀",
    status: "已完结",
    rating: 9.3,
    views: "705.9万",
    favorites: "44.1万",
    year: 2020,
    updateTime: "2026-07-25",
    latestChapter: "第260话 真相大白",
    totalChapters: 260,
    description:
      "天才少女侦探与退役刑警搭档，经营着一间不起眼的“迷雾侦探社”。一桩桩看似毫无头绪的悬案，在他们缜密的推理下一一浮出水面。每一案都烧脑反转，让人欲罢不能。",
    tags: ["推理", "悬疑", "烧脑", "破案"],
    hot: 4,
  },
  {
    id: "slam-dunk-team",
    title: "热血篮球队",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20passionate%20young%20basketball%20player%20in%20a%20red%20jersey%20leaping%20for%20a%20slam%20dunk%20on%20an%20outdoor%20court%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20warm%20yellow%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20energetic%20composition&width=450&height=600&seq=manga-cover-02&orientation=portrait",
    category: "sports",
    categoryName: "体育",
    author: "飞跃",
    status: "连载中",
    rating: 9.3,
    views: "786.4万",
    favorites: "47.3万",
    year: 2021,
    updateTime: "2026-07-29",
    latestChapter: "第128话 决胜时刻",
    totalChapters: 128,
    description:
      "一支由问题少年组成的校篮球队，在菜鸟教练带领下冲击全国大赛的青春热血故事。一次次逆风翻盘、一声声球场嘶吼，把篮球的燃与青春的甜都画给你看。",
    tags: ["篮球", "校园", "青春", "热血"],
    hot: 5,
  },
  {
    id: "dessert-love",
    title: "甜品店恋爱物语",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20sweet%20girl%20holding%20a%20strawberry%20cake%20in%20a%20cozy%20pastel%20dessert%20shop%20with%20a%20gentle%20smile%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20pink%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20sweet%20atmosphere&width=450&height=600&seq=manga-cover-06&orientation=portrait",
    category: "romance",
    categoryName: "恋爱",
    author: "糖霜酱",
    status: "已完结",
    rating: 9.1,
    views: "523.7万",
    favorites: "31.5万",
    year: 2020,
    updateTime: "2026-07-22",
    latestChapter: "第180话 甜过初恋",
    totalChapters: 180,
    description:
      "甜品师小满的梦想是做出全世界最幸福的蛋糕，直到冷面西点大师走进她的店。一个甜甜的店、一个傲娇的人，和一块块融化人心的甜品，恋爱与美食的双重暴击。",
    tags: ["恋爱", "美食", "甜品", "治愈"],
    hot: 6,
  },
  {
    id: "delivery-hero",
    title: "都市外卖侠",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20cheerful%20food%20delivery%20rider%20on%20a%20scooter%20wearing%20a%20yellow%20helmet%20riding%20through%20a%20modern%20city%20street%20at%20dusk%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20peach%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20energetic%20composition&width=450&height=600&seq=manga-cover-04&orientation=portrait",
    category: "urban",
    categoryName: "都市",
    author: "街角猫",
    status: "连载中",
    rating: 8.8,
    views: "368.9万",
    favorites: "21.7万",
    year: 2022,
    updateTime: "2026-07-27",
    latestChapter: "第96话 深夜订单",
    totalChapters: 96,
    description:
      "穿梭在城市大街小巷的外卖骑手阿飞，每天送出的不只是美食，还有形形色色的人生故事。轻松搞笑的都市生活画卷，笑着笑着就感动了。",
    tags: ["都市", "搞笑", "生活", "温情"],
    hot: 7,
  },
  {
    id: "desk-mate",
    title: "学霸同桌是冤家",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20serious%20boy%20and%20a%20cheerful%20girl%20sitting%20at%20a%20school%20desk%20playfully%20arguing%20in%20a%20bright%20classroom%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20light%20green%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20youthful%20composition&width=450&height=600&seq=manga-cover-07&orientation=portrait",
    category: "romance",
    categoryName: "恋爱",
    author: "青柠泡泡",
    status: "连载中",
    rating: 8.9,
    views: "412.6万",
    favorites: "25.3万",
    year: 2022,
    updateTime: "2026-07-26",
    latestChapter: "第88话 期末考试",
    totalChapters: 88,
    description:
      "年级第一的冷面学霸，偏偏坐到了元气少女旁边。一个嫌她吵，一个嫌他闷，天天斗嘴互坑，却也在一次次“战争”里悄悄心动。校园恋爱的酸甜日常，青春感拉满。",
    tags: ["校园", "恋爱", "搞笑", "青春"],
    hot: 8,
  },
  {
    id: "fight-girl",
    title: "格斗少女",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20fierce%20martial%20arts%20girl%20in%20a%20red%20gi%20striking%20a%20fighting%20pose%20in%20a%20traditional%20dojo%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20warm%20grey%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20dynamic%20composition&width=450&height=600&seq=manga-cover-13&orientation=portrait",
    category: "hot-blood",
    categoryName: "热血",
    author: "铁拳阿花",
    status: "连载中",
    rating: 9.0,
    views: "478.3万",
    favorites: "29.6万",
    year: 2021,
    updateTime: "2026-07-28",
    latestChapter: "第105话 全国大赛",
    totalChapters: 105,
    description:
      "为了继承父亲的道场，内向少女阿樱踏上格斗之路。从被嘲笑到站上全国大赛的擂台，她用一拳一拳打出属于自己的传奇。拳拳到肉的燃，也有少女细腻的心事。",
    tags: ["格斗", "热血", "成长", "励志"],
    hot: 9,
  },
  {
    id: "ring-boy",
    title: "拳台上的少年",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20determined%20teenage%20boxer%20wearing%20red%20boxing%20gloves%20standing%20in%20a%20boxing%20ring%20under%20bright%20spotlights%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20beige%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20dramatic%20composition&width=450&height=600&seq=manga-cover-03&orientation=portrait",
    category: "hot-blood",
    categoryName: "热血",
    author: "八角笼",
    status: "已完结",
    rating: 9.0,
    views: "452.1万",
    favorites: "27.8万",
    year: 2019,
    updateTime: "2026-07-20",
    latestChapter: "第216话 冠军之路",
    totalChapters: 216,
    description:
      "从街头小巷到职业拳台，少年阿豪用拳头对抗命运。每一场硬仗、每一次倒下再爬起，都是对梦想最滚烫的告白。看完你会想握紧拳头说一声：燃爆了！",
    tags: ["拳击", "热血", "励志", "成长"],
    hot: 10,
  },
  {
    id: "midnight-store",
    title: "深夜便利店",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20friendly%20convenience%20store%20clerk%20standing%20behind%20a%20glowing%20counter%20of%20a%20cozy%20late%20night%20store%20with%20warm%20lights%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20cream%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20cozy%20atmosphere&width=450&height=600&seq=manga-cover-05&orientation=portrait",
    category: "urban",
    categoryName: "都市",
    author: "守夜人",
    status: "连载中",
    rating: 8.7,
    views: "295.3万",
    favorites: "18.2万",
    year: 2023,
    updateTime: "2026-07-24",
    latestChapter: "第64话 不速之客",
    totalChapters: 64,
    description:
      "一家24小时营业的便利店，收留着深夜里的每个疲惫灵魂。加班的白领、失恋的少女、迷路的老爷爷……暖黄色的灯光下，一段段治愈的小故事悄悄上演。",
    tags: ["都市", "治愈", "温情", "日常"],
    hot: 11,
  },
  {
    id: "sprint-girl",
    title: "田径少女向前冲",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20determined%20girl%20sprinter%20in%20a%20sports%20uniform%20racing%20on%20an%20athletic%20track%20in%20a%20bright%20stadium%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20peach%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20energetic%20composition&width=450&height=600&seq=manga-cover-15&orientation=portrait",
    category: "sports",
    categoryName: "体育",
    author: "风速酱",
    status: "连载中",
    rating: 8.7,
    views: "289.4万",
    favorites: "17.6万",
    year: 2023,
    updateTime: "2026-07-26",
    latestChapter: "第72话 百米冲刺",
    totalChapters: 72,
    description:
      "天赋平平却执着到偏执的少女小鹿，立志跑进省队。在教练和队友的陪伴下，她用一次次起跑、一次次撞线，证明普通人的坚持也能闪闪发光。",
    tags: ["田径", "体育", "青春", "励志"],
    hot: 12,
  },
  {
    id: "foodie-rise",
    title: "吃货的逆袭",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20chubby%20happy%20boy%20eating%20a%20huge%20bowl%20of%20noodles%20with%20steam%20rising%20in%20a%20cozy%20kitchen%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20yellow%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20fun%20atmosphere&width=450&height=600&seq=manga-cover-16&orientation=portrait",
    category: "comedy",
    categoryName: "搞笑",
    author: "大碗宽面",
    status: "连载中",
    rating: 8.8,
    views: "342.8万",
    favorites: "20.1万",
    year: 2022,
    updateTime: "2026-07-27",
    latestChapter: "第83话 大胃王挑战",
    totalChapters: 83,
    description:
      "干啥啥不行、吃饭第一名的小胖，意外觉醒美食天赋，一路从路边摊吃到大胃王赛场。搞笑到喷饭，看完立刻想点外卖！",
    tags: ["美食", "搞笑", "逆袭", "日常"],
    hot: 13,
  },
  {
    id: "time-studio",
    title: "时光照相馆",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20nostalgic%20young%20photographer%20holding%20an%20old%20film%20camera%20in%20a%20vintage%20photo%20studio%20with%20warm%20amber%20light%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20cream%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20nostalgic%20atmosphere&width=450&height=600&seq=manga-cover-14&orientation=portrait",
    category: "urban",
    categoryName: "都市",
    author: "快门先生",
    status: "已完结",
    rating: 8.9,
    views: "356.7万",
    favorites: "22.4万",
    year: 2022,
    updateTime: "2026-07-18",
    latestChapter: "第150话 定格美好",
    totalChapters: 150,
    description:
      "街角一家老照相馆，藏着一台能拍出“回忆”的神奇相机。每个来拍照的人，都会在照片里看到最想留住的时光。温柔、治愈、让人鼻酸又微笑的故事合集。",
    tags: ["治愈", "奇幻", "都市", "温情"],
    hot: 14,
  },
  {
    id: "dragon-apprentice",
    title: "龙族见习生",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20cute%20young%20dragon%20apprentice%20with%20small%20wings%20breathing%20a%20tiny%20fire%20ball%20standing%20on%20a%20misty%20mountain%20cliff%20at%20sunrise%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20orange%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20whimsical%20atmosphere&width=450&height=600&seq=manga-cover-09&orientation=portrait",
    category: "fantasy",
    categoryName: "玄幻",
    author: "云上龙",
    status: "连载中",
    rating: 8.6,
    views: "287.5万",
    favorites: "16.9万",
    year: 2023,
    updateTime: "2026-07-25",
    latestChapter: "第58话 初试龙息",
    totalChapters: 58,
    description:
      "资质垫底的龙族少年小炎，连喷个火球都会打嗝。为了通过龙族考核，他踏上收集龙之力的冒险之旅，一路笑料百出又危机四伏，最终成长为真正的守护之龙。",
    tags: ["玄幻", "冒险", "搞笑", "成长"],
    hot: 15,
  },
  {
    id: "coder-guide",
    title: "程序员求生指南",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20comic%20cover%20of%20a%20relaxed%20programmer%20sitting%20at%20a%20desk%20with%20a%20laptop%20and%20coffee%20cup%20in%20a%20cozy%20apartment%20office%2C%20bold%20black%20outlines%2C%20clean%20solid%20soft%20warm%20grey%20gradient%20background%2C%20professional%20manga%20cover%20art%2C%20high%20detail%2C%20casual%20atmosphere&width=450&height=600&seq=manga-cover-11&orientation=portrait",
    category: "urban",
    categoryName: "都市",
    author: "秃头代码",
    status: "连载中",
    rating: 8.5,
    views: "236.1万",
    favorites: "14.3万",
    year: 2023,
    updateTime: "2026-07-23",
    latestChapter: "第47话 上线之夜的救赎",
    totalChapters: 47,
    description:
      "一只程序猿的爆笑求生日常：需求改来改去、Bug 春风吹又生、发际线一去不复返。每一格都是打工人真实写照，笑着笑着就哭了。",
    tags: ["都市", "职场", "搞笑", "日常"],
    hot: 16,
  },
];